import React, { PropTypes, Component } from 'react'
import GoogleMap from 'google-map-react'
import { isEqual, debounce } from 'lodash'

import './Map.scss'
import Marker from './components/Marker'

import { geocode } from 'utils/google-maps'
import { buildAddressString } from 'utils/addresses'

class Map extends Component {
  constructor (props) {
    super(props)

    this.debounceWait = 500
    this.mapOptions = this.mapOptions.bind(this)
    this.setCenter = this.setCenter.bind(this)
    this.setCenterWithAddress = debounce(this.setCenterWithAddress, this.debounceWait)
  }

  componentWillReceiveProps (nextProps) {
    const sameAddress = isEqual(this.props.address, nextProps.address)

    if (!sameAddress) {
      this.setCenterWithAddress(nextProps.address)
      return
    }
  }

  componentWillUnmount () {
    this.setCenterWithAddress.cancel()
  }

  setCenterWithAddress (address) {
    const addressString = buildAddressString(address)
    geocode(addressString)
      .then(this.setCenter)
  }

  setCenter (center) {
    this.props.onChange(center)
  }

  mapOptions (map) {
    const { draggable } = this.props
    return {
      draggable,
      scrollwheel: draggable,
      zoomControl: draggable
    }
  }

  render () {
    const { location } = this.props

    return (
      <div className='Map'>
        <GoogleMap
          center={location}
          onChange={
            ({center}) => this.setCenter(center)
          }
          defaultZoom={16}
          options={this.mapOptions}
          />

        <Marker />
      </div>
    )
  }
}
Map.displayName = 'Map'
Map.propTypes = {
  location: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  address: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  draggable: PropTypes.bool
}
Map.defaultProps = {
  draggable: true
}

export default Map



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/shared/components/Map/Map.js